module.exports = __webpack_public_path__ + "img/grayscale_medium.6cd29efa.webp";